@let q = question();
<div class="wrapper" [formGroup]="form">
  <app-feedback-title [title]="q.title" [subtitle]="q.subtitle"></app-feedback-title>
  <textarea [value]="text" (input)="updateText($event)" rows="5"></textarea>
</div>
